import React from 'react';
import { Checkbox } from './components/Checkbox';

type SimpleCheckboxProps = {
  labelText: string,
  checked: boolean,
  disabled: boolean,
  onChange: (param: any) => void,
};

function SimpleCheckbox({
  labelText,
  checked,
  onChange,
  disabled = false,
}: SimpleCheckboxProps) {
  return (
    <div className="items-top flex space-x-2 my-1">
      <Checkbox
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
      <label
        htmlFor={`${labelText}-checkbox`}
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {labelText}
      </label>
    </div>
  );
}

export default SimpleCheckbox;
